import jwtDecode from 'jwt-decode';
import { tensaiPrivClient } from './api';

// token
const TOKEN_KEY = 'Authorization';
const CHANGE_PASSWORD_TOKEN = 'CHANGE_PASSWORD_TOKEN'

/**
 * Auth Service
 */
export default class AuthService {
  /**
   * Check if user is authenticated
   */
  isAuthenticated() { return (localStorage.getItem(TOKEN_KEY) !== null); }

  /**
   * Get JWT token from storage
   */
  getToken() { return localStorage.getItem(TOKEN_KEY); }

  /**
   * Get user from JWT token
   */
  getDecodedUser() { return jwtDecode(this.getToken()); }

  /**
   * Set JWT token to storage
   */
  setToken(token, callback) {
    localStorage.setItem(TOKEN_KEY, token);
    if (callback) callback();
  }

  /**
   * Remove JWT token to storage
   */
  removeToken(callback) {
    localStorage.removeItem(TOKEN_KEY);
    if (callback) callback();
  }

  /**
   * manipulações no token de alterar senha
   */
  // returna trua caso o token esteja no localStorage
  isChangePasswordToken() { return localStorage.getItem(CHANGE_PASSWORD_TOKEN) !== null }
  // busca o item no localStorage 
  getChangePasswordToken() { return localStorage.getItem(CHANGE_PASSWORD_TOKEN) }
  // seta o token para o localStorage
  setChangePasswordToken(token) { return localStorage.setItem(CHANGE_PASSWORD_TOKEN, token) }
  // remove o token para o localStorage
  removeChangePasswordToken() { return localStorage.removeItem(CHANGE_PASSWORD_TOKEN) }

  async isValidToken(token) {
    const tokenValidate = await tensaiPrivClient.post('/security/token', {}, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })

    return tokenValidate.status === 200
  }
}
